// extracted by css-extract-rspack-plugin
export default {"cls1":"UserListMenu-cls1_uRb","cls2":"UserListMenu-cls2_A5G UserListMenu-cls1_uRb"};